






































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import MembershipDemand from "../../store/entities/membershipDemand";
import Ajax from "../../lib/ajax";


@Component({
  components: {  },
})
export default class EditMembershipDemand extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  membershipDemand: MembershipDemand = new MembershipDemand();
  courtList = [];
  demandTypeList = [
    {
      label: "买入",
      value: 0,
    },
    {
      label: "卖出",
      value: 1,
    },
  ];
  get extData() {
    return {
      membershipDemandId: this.membershipDemand.id,
    };
  }
  async created() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }

  save() {
    (this.$refs.membershipDemandForm as any).validate(
      async (valid: boolean) => {
        if (valid) {
          await this.$store.dispatch({
            type: "membershipDemand/update",
            data: this.membershipDemand
          });
          (this.$refs.membershipDemandForm as any).resetFields();
          this.$Message.success('修改成功');
          this.$emit("save-success");
          this.$emit("input", false);
        }
      }
    );
  }
  cancel() {
    (this.$refs.membershipDemandForm as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.membershipDemand = Util.extend(
        true,
        {},
        this.$store.state.membershipDemand.editMembershipDemand
      );
    }
  }

  membershipDemandRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Title")),
        trigger: "blur",
      },
      {
        type: "string",
        max: 512,
        message: this.L("NoMoreThenLength", undefined, this.L("Title"), "512"),
        trigger: "blur",
      },
    ],
    phoneNumber: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("PhoneNumber")),
        trigger: "blur",
      },
      {
        type: "string",
        max: 32,
        message: this.L(
          "NoMoreThenLength",
          undefined,
          this.L("PhoneNumber"),
          "32"
        ),
        trigger: "blur",
      },
      {
        pattern:
          /(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/,
        message: this.L("IncorrectFormat", undefined, this.L("PhoneNumber")),
        trigger: "blur",
      },
    ],
    remark: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Description")),
        trigger: "blur",
      },
    ],
  };
}
